import { render, staticRenderFns } from "./MetaInfo.vue?vue&type=template&id=2ac3bc98&scoped=true&"
import script from "./MetaInfo.vue?vue&type=script&lang=ts&"
export * from "./MetaInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MetaInfo.vue?vue&type=style&index=0&id=2ac3bc98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3bc98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTextField,VTooltip})
